import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EmojifyPipe } from '../pipe/emojify.pipe';
import { Athlete } from "../../common/models/athlete";
import { Organization } from "../../common/models/organization";
import { LowerCasePipe, NgFor, NgIf } from "@angular/common";
import { DateClosestPipe } from "../../common/pipes/date-closest";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { User } from "../../common/models/user";


@Component({
  selector: 'app-chat-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    LowerCasePipe,
    DateClosestPipe,
    TranslateModule,
    EmojifyPipe,
    NgIf,
    NgFor,
    FlexLayoutModule,
  ],
  providers: [EmojifyPipe]
})
export class MessageComponent {
    @Input()
    public message: any;

    @Input()
    public appUrl = '';

    @Input()
    public mobileDisplay = false;

    @Input()
    public athleteUser: User = {} as User;

    @Input()
    public organization: Organization = {} as Organization;

    @Output()
    public linkClickedEvent = new EventEmitter();

    @Output()
    public downloadClickedEvent = new EventEmitter();

    public onDownloadClicked(message:any) {
        this.downloadClickedEvent.emit(message);
    }

    public onLinkClicked(url: string) {
        this.linkClickedEvent.emit(url);
    }

    public createLink() {
        const mobileLinkPart = this.message.linkUrl.split('/').slice(1).join('/');

        return '/' + (this.mobileDisplay ?
            this.organization!.code + '/app/athletes/' + this.athleteUser.id + '/' + mobileLinkPart :
            this.message.linkUrl
        );
    }
}
